export default function OverlayGredientColor() {
  return (
    <>
      <div
        className="absolute w-50 h-50 bg-gradient-to-bl from-tealGreen from-50% to-charcoalGray to-60% blur-400 rounded-full -top-64 -right-14 -z-1"
        aria-hidden="true"
      ></div>
    </>
  );
}
